import {
	generateSerpMonitoringReport,
	getSerpMonitoringConfigs,
} from '@/API/repositories/serpMonitoring';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useState } from 'react';
import { SERP_MONITORING_ERROR_MESSAGE } from '@/common/constants/serpMonitoring';

const useSerpMonitoring = () => {
	const [show, setShow] = useState(false);
	const [selectedConfig, setSelectedConfig] = useState();
	const [configs, setConfigs] = useState([]);

	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const isLoading =
		hasUnfilledRequest(getSerpMonitoringConfigs);

	const loadConfigs = async () => {
		setConfigs([]);
		const response = await makeRequest(getSerpMonitoringConfigs);

		if (!response?.data) {
			return addMessage(SERP_MONITORING_ERROR_MESSAGE, 'error');
		}

		setConfigs(response.data);
	};

	const handleGenerate = async (payload) => {
		addMessage('Generating SERP report in progess', 'success');

		const response = await makeRequest(
			generateSerpMonitoringReport.bind(null, payload),
		);

		if (!response?.data) {
			return addMessage('Generate failed', 'error');
		}

		addMessage('SERP report generated', 'success');
	};

	const handleAddConfig = () => {
		setSelectedConfig(null);
		setShow(true);
	};

	useEffect(() => {
		loadConfigs();
	}, []);

	return {
		show,
		setShow,
		selectedConfig,
		setSelectedConfig,
		configs,
		isLoading,
		loadConfigs,
		handleGenerate,
		handleAddConfig,
	};
};

export default useSerpMonitoring;
